import { useEffect } from "react";

import * as Sentry from "@sentry/react";

import ChargebeeCheckout from "../components/ChargebeeCheckout/ChargebeeCheckout";
import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import { paymentPlatformSentryTag } from "../hooks/useAccount";

const CheckoutPage = () => {
  useEffect(() => {
    Sentry.setTag(paymentPlatformSentryTag, "chargebee");
  }, []);

  return (
    <UnderMaintenanceOrChildren>
      <ChargebeeCheckout />
    </UnderMaintenanceOrChildren>
  );
};

export default CheckoutPage;
